const LEGACY_BOOKING_HOSTNAME = "bookings.stagnesholidaypark.com"

function isLegacyBookingUrl(href, baseUrl = window.location.origin) {
  try {
    return new URL(href, baseUrl).hostname === LEGACY_BOOKING_HOSTNAME
  } catch {
    return false
  }
}

function findBookingSearchForm(root) {
  return (
    root.querySelector(".searchBarContainer.on-page form") ??
    root.querySelector(".searchBarContainer form") ??
    root.querySelector(".searchBarMobile form")
  )
}

function submitBookingSearch(root) {
  const form = findBookingSearchForm(root)

  if (!form) {
    return false
  }

  const submitButton = form.querySelector("#availability-search-button, button[type='submit'], input[type='submit']")

  if (typeof form.requestSubmit === "function") {
    form.requestSubmit(submitButton ?? undefined)
  } else {
    submitButton?.click()
  }

  return true
}

function initialiseBookingSearchCtas(root = document) {
  root.addEventListener("click", (event) => {
    const link = event.target?.closest?.("a[href]")

    if (!link || !isLegacyBookingUrl(link.href)) {
      return
    }

    event.preventDefault()

    if (!submitBookingSearch(root)) {
      window.location.assign("/search")
    }
  })
}

export { findBookingSearchForm, initialiseBookingSearchCtas, isLegacyBookingUrl, submitBookingSearch }
